import { useCallback, useState, useRef} from "react";
import { API } from 'aws-amplify';

const OAUTH_STATE_KEY = process.env.REACT_APP_OAUTH_STATE_KEY
const POPUP_HEIGHT = 700;
const POPUP_WIDTH = 700;
const OAUTH_RESPONSE = process.env.REACT_APP_OAUTH_RESPONSE;

const apiName = process.env.REACT_APP_ENDPOINT_NAME
const path = process.env.REACT_APP_ENDPOINT_PATH

function useLocalStorage(key, initialValue) {
  // State to store our value
  // Pass initial state function to useState so logic is only executed once
  const [storedValue, setStoredValue] = useState(() => {
    if (typeof window === "undefined") {
      return initialValue;
    }
    try {
      // Get from local storage by key
      const item = window.localStorage.getItem(key);
      // Parse stored json or if none return initialValue
      return item ? JSON.parse(item) : initialValue;
    } catch (error) {
      // If error also return initialValue
    console.log("in error")
      console.log(error);
      return initialValue;
    }
  });
  // Return a wrapped version of useState's setter function that ...
  // ... persists the new value to localStorage.
  const setValue = (value) => {
    try {
      // Allow value to be a function so we have same API as useState
      const valueToStore =
        value instanceof Function ? value(storedValue) : value;
      // Save state
      setStoredValue(valueToStore);
      // Save to local storage
      if (typeof window !== "undefined") {
        window.localStorage.setItem(key, JSON.stringify(valueToStore));
      }
    } catch (error) {
      // A more advanced implementation would handle the error case
      console.log(error);
    }
  };
  return [storedValue, setValue];
}

const generateState = () => {
    const validChars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
    let array = new Uint8Array(40);
	window.crypto.getRandomValues(array);
	array = array.map((x) => validChars.codePointAt(x % validChars.length));
	const randomState = String.fromCharCode.apply(null, array);
	return randomState;
};

const saveState = (state) => {
    sessionStorage.setItem(OAUTH_STATE_KEY, state);
};

const saveURL = (href) => {
    sessionStorage.setItem("callinghref", href);
}

const saveSelectedSubscription = (selectedSubscription) => {
    sessionStorage.setItem("selectedSubscription", selectedSubscription);
}

const removeState = () => {
    sessionStorage.removeItem(OAUTH_STATE_KEY);
};

const openPopup = (url) => {
    const top = window.outerHeight / 2 + window.screenY - POPUP_HEIGHT / 2;
    const left = window.outerHeight / 2 + window.screenX - POPUP_HEIGHT / 2;
    return window.open(
        url,
        '_self'
        // 'Xero OAuth',
        // `height=${POPUP_HEIGHT},width=${POPUP_WIDTH},top=${top},left=${left}`
    );
};

const closePopup = (popupRef) => {
    popupRef.current?.close();
};

const cleanup = (
	intervalRef,
	popupRef,
	handleMessageListener
) => {
	clearInterval(intervalRef.current);
	closePopup(popupRef);
	removeState();
	window.removeEventListener('message', handleMessageListener);
};

const enhanceAuthorizeUrl = (
    authorizeUrl,
    clientId,
    redirectUri,
    scope,
    state
) => {
    return `${authorizeUrl}?response_type=code&client_id=${clientId}&redirect_uri=${redirectUri}&scope=${scope}&state=${state}`;
};

const useOAuth2 = (props) => {
    const {
        authorizeUrl,
        clientId,
        redirectUri,
        scope = '',
        responseType,
        selectedSubscription = ''
    } = props;

    const popupRef = useRef();
    const intervalRef = useRef();
    const [{ loading, error}, setUI] = useState({ loading: false, error: null});
    // const [data, setData] = useState(null);
    const [data, setData] = useLocalStorage(
        // `${authorizeUrl}-${clientId}-${scope}`,
        process.env.REACT_APP_OAUTH_STATE_KEY,
		{
			defaultValue: null,
		}
    )

    const getAuth = useCallback(() => {
        setUI({
            loading: true,
            error: null
        });
        const state = generateState();
        saveState(state);
        saveURL(window.location.href);
        saveSelectedSubscription(selectedSubscription);
        popupRef.current = openPopup(
            enhanceAuthorizeUrl(authorizeUrl, clientId, redirectUri, scope, state)
        );

        async function handleMessageListener(message) {
            console.log("in async");
            console.log(message);
        //     message.data.type not set
        try {
          const type = message && message.data && message.data.type;
          if (type === OAUTH_RESPONSE) {
              console.log("OAUTH_RESPONSE")
            const errorMaybe = message && message.data && message.data.error;
            if (errorMaybe) {
              setUI({
                loading: false,
                error: errorMaybe || 'Unknown Error',
              });
            } else {
                console.log("Going to call API")
                let payload = message?.data?.payload;
                console.log(payload)
                const myInit = {
                    headers: {
                    },
                    response: true,
                    queryStringParameters: {
                        "code": payload.code,
                        "scope": payload.scope,
                        "state": payload.state,
                        "redirect_uri": process.env.REACT_APP_redirectSignIn + `callback`,
                        "pathname": window.location.pathname,
                        "selectedSubscription": selectedSubscription
                        // "redirect_uri": `${document.location.origin}/callback`
                    }
                }
                // console.log(payload)
                API.get(apiName, path, myInit)
                    .then(response => {
                        console.log(response);
                        setData(response);
                    })
                    .catch(error => {
                        console.log(error.response);
                        setData({"data":"Incorrect User Signed In to Xero"});
                        setUI({
                            loading:false,
                            error: error?.response?.data
                        })
                    })
              //const code = message && message.data && message.data.payload && message.data.payload.code;
              // ... Check next step to see what we'll do with the code
              setUI({
                  loading: false,
                   error: null,
              });

            }
          }
        } catch (genericError) {
          console.error(genericError);
          setUI({
            loading: false,
            error: genericError.toString(),
          });
        } finally {
            console.log("in finally")
            console.log(data)
            console.log(loading)
            // console.log(window.localStorage.getItem(process.env.REACT_APP_OAUTH_STATE_KEY))
            if (window.localStorage.getItem(process.env.REACT_APP_OAUTH_STATE_KEY)!=null){
                // Clear stuff ...
                cleanup(intervalRef, popupRef, handleMessageListener);
            }
            // if (JSON.stringify(data) != '{"defaultValue":null}'){
            //     // Clear stuff ...
            //     cleanup(intervalRef, popupRef, handleMessageListener);
            // }
            // Clear stuff ...
            // cleanup(intervalRef, popupRef, handleMessageListener);

        }
      }
      window.addEventListener('message', handleMessageListener);

      intervalRef.current = setInterval(() => {
        const popupClosed = !popupRef.current || !popupRef.current.window || popupRef.current.window.closed;
        if (popupClosed) {
          // Popup was closed before completing auth...
          setUI((ui) => ({
            ...ui,
            loading: false,
          }));
          console.warn('Warning: Popup was closed before completing authentication.');
          clearInterval(intervalRef.current);
          removeState();
          window.removeEventListener('message', handleMessageListener);
        }
      }, 250);

      return () => {
        window.removeEventListener('message', handleMessageListener);
        if (intervalRef.current) clearInterval(intervalRef.current);
      };
    }, [
        authorizeUrl,
        clientId,
        redirectUri,
        scope,
        setUI,
    ]);
    console.log(data);
    console.log(loading);
    console.log(error);
    return { data, loading, error, getAuth }
};

export default useOAuth2;